import Typography from "@mui/material/Typography";
import React from "react";
import blueLogo from "./assets/bluelogo.svg";
import { useNavigate } from "react-router";

interface IHeaderProps {
    Title: string;
}

export default function Header({ Title }: IHeaderProps) {
        let navigate = useNavigate();
    return (
        <div
            style={{
                display: "flex",
                backgroundColor: "#e5e7eb",

                alignItems: "center",
                padding: "10px 25px",
                borderRadius: "8px",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <img
                alt="NS"
                src={blueLogo}
                loading="lazy"
                width="45px"
                height="45px"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
            />{" "}
            <Typography variant="h4" sx={{textAlign: "right"}}>{Title}</Typography>
        </div>
    );
}
